module.exports = __webpack_public_path__ + "img/Lexus_logo.be033050.png";